var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "registry-edit-field",
      class: { "registry-edit-wide": _vm.field.wide },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-1",
        },
        [
          _c(
            "label",
            {
              staticClass: "mb-0",
              attrs: {
                id: `${_vm.id}-label`,
                for:
                  _vm.field.rows || _vm.field.type === "choices"
                    ? null
                    : _vm.id,
              },
            },
            [
              _vm._v(_vm._s(_vm.field.label) + " "),
              _vm.changed
                ? _c("small", { staticClass: "text-primary" }, [
                    _vm._v("Changed"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          !_vm.grouped
            ? _c(
                "b-dropdown",
                {
                  attrs: {
                    size: "sm",
                    variant: "link",
                    right: "",
                    "no-caret": "",
                    text: "⋯",
                    "toggle-attrs": {
                      "aria-label": `${_vm.field.label} options`,
                    },
                  },
                },
                [
                  _vm.field.key !== "display_number"
                    ? _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("choose", "blank")
                            },
                          },
                        },
                        [_vm._v("Leave blank")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fact.source === "correction"
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { disabled: !_vm.hasSource },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("choose", "source")
                            },
                          },
                        },
                        [_vm._v("Use source value")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.changed
                    ? _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("undo")
                            },
                          },
                        },
                        [_vm._v("Undo field change")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.draft.mode === "source"
        ? _c("div", { staticClass: "small border rounded p-2" }, [
            _c("strong", [_vm._v("Use source value")]),
            _c("div", [_vm._v(_vm._s(_vm.sourceSummary(_vm.fact)))]),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-link p-0",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("undo")
                  },
                },
              },
              [_vm._v("Undo")]
            ),
          ])
        : [
            _vm.field.rows
              ? _c(
                  "div",
                  {
                    attrs: {
                      role: "group",
                      "aria-labelledby": `${_vm.id}-label`,
                    },
                  },
                  [
                    _vm._l(_vm.draft.rows, function (row, index) {
                      return _c(
                        "div",
                        {
                          key: row.id,
                          staticClass: "d-flex mb-1 align-items-start",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "sr-only",
                              attrs: { for: `${_vm.id}-${row.id}` },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.field.label) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          /[\r\n]/.test(row.value)
                            ? _c("textarea", {
                                staticClass: "form-control form-control-sm",
                                attrs: { id: `${_vm.id}-${row.id}`, rows: "2" },
                                domProps: { value: row.value },
                                on: {
                                  input: function ($event) {
                                    return _vm.$emit("row-input", {
                                      row,
                                      value: $event.target.value,
                                    })
                                  },
                                },
                              })
                            : _c("input", {
                                staticClass: "form-control form-control-sm",
                                class: { "is-invalid": _vm.error },
                                attrs: {
                                  id: `${_vm.id}-${row.id}`,
                                  "aria-describedby": `${_vm.id}-help`,
                                },
                                domProps: { value: row.value },
                                on: {
                                  input: function ($event) {
                                    return _vm.$emit("row-input", {
                                      row,
                                      value: $event.target.value,
                                    })
                                  },
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-link",
                              attrs: {
                                type: "button",
                                "aria-label": `Remove ${_vm.field.singular} ${
                                  index + 1
                                }`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("remove-row", row)
                                },
                              },
                            },
                            [_vm._v("Remove")]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("add-row")
                          },
                        },
                      },
                      [_vm._v("Add " + _vm._s(_vm.field.singular))]
                    ),
                  ],
                  2
                )
              : _vm.field.type === "choices"
              ? _c(
                  "div",
                  {
                    attrs: {
                      id: _vm.id,
                      role: "group",
                      "aria-labelledby": `${_vm.id}-label`,
                    },
                  },
                  [
                    _vm._l(_vm.choices, function (choice) {
                      return _c(
                        "label",
                        { key: choice, staticClass: "mr-3 small" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: _vm.tokens.includes(choice) },
                            on: {
                              change: function ($event) {
                                return _vm.toggle(choice, $event.target.checked)
                              },
                            },
                          }),
                          _vm._v(" " + _vm._s(choice)),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "small d-block mb-1",
                        attrs: { for: `${_vm.id}-other` },
                      },
                      [_vm._v("Other reported values")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control form-control-sm",
                      attrs: { id: `${_vm.id}-other` },
                      domProps: { value: _vm.unknown.join(", ") },
                      on: {
                        input: function ($event) {
                          return _vm.updateUnknown($event.target.value)
                        },
                      },
                    }),
                  ],
                  2
                )
              : _vm.field.type === "status"
              ? _c(
                  "select",
                  {
                    staticClass: "custom-select custom-select-sm",
                    class: { "is-invalid": _vm.error },
                    attrs: { id: _vm.id },
                    domProps: { value: _vm.draft.value },
                    on: {
                      change: function ($event) {
                        return _vm.input($event.target.value)
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Not reported / left blank"),
                    ]),
                    _vm._l(_vm.statusOptions, function (choice) {
                      return _c(
                        "option",
                        { key: choice, domProps: { value: choice } },
                        [_vm._v(_vm._s(choice))]
                      )
                    }),
                  ],
                  2
                )
              : /[\r\n]/.test(_vm.draft.value)
              ? _c("textarea", {
                  staticClass: "form-control form-control-sm",
                  attrs: { id: _vm.id, rows: "2" },
                  domProps: { value: _vm.draft.value },
                  on: {
                    input: function ($event) {
                      return _vm.input($event.target.value)
                    },
                  },
                })
              : _c("input", {
                  staticClass: "form-control form-control-sm",
                  class: { "is-invalid": _vm.error },
                  attrs: {
                    id: _vm.id,
                    type: _vm.inputType,
                    "aria-invalid": !!_vm.error,
                    "aria-describedby": `${_vm.id}-help`,
                  },
                  domProps: { value: _vm.draft.value },
                  on: {
                    input: function ($event) {
                      return _vm.input(
                        $event.target.value,
                        $event.target.validity.badInput
                      )
                    },
                  },
                }),
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small mt-1", attrs: { id: `${_vm.id}-help` } },
        [
          _vm.error
            ? _c(
                "span",
                { staticClass: "text-danger", attrs: { role: "alert" } },
                [_vm._v(_vm._s(_vm.error))]
              )
            : _vm.draft.mode === "blank" || (!_vm.changed && _vm.fact.is_blank)
            ? _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "Left blank. Source values stay hidden until the correction is removed."
                ),
              ])
            : _vm.field.key === "display_number"
            ? _c("span", { staticClass: "text-muted" }, [
                _vm._v("Formatting only; keep the same letters and digits."),
              ])
            : _vm.fact.source === "correction"
            ? _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  _vm._s(
                    _vm.provisional
                      ? "Initial manual value"
                      : "Admin correction"
                  )
                ),
              ])
            : _vm.field.type === "date" &&
              _vm.fact.value &&
              !_vm.validDate(_vm.fact.value)
            ? _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "Unrecognized source date. Retained until edited; use YYYY-MM-DD for a new value."
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.fact.differing_evidence
        ? _c(
            "details",
            { staticClass: "small text-muted" },
            [
              _c("summary", [_vm._v("Source values differ")]),
              _vm._l(
                _vm.fact.alternatives || [],
                function (alternative, index) {
                  return _c("div", { key: index }, [
                    _vm._v(_vm._s(alternative.value)),
                  ])
                }
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }